import * as APPOINTMENT from '../constants/appointment';


export default {
  [APPOINTMENT.MUTATE_LIST_APPOINTMENT]: (state, data) => {
    state.list = data;
  }
}



// WEBPACK FOOTER //
// ./src/store/appointment/mutations.js